import propTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import CloseModalButton from 'shared/components/CloseModalButton';
import * as Colors from 'material-ui/styles/colors';
import ErrorIcon from 'material-ui/svg-icons/alert/error';
import InlineButton from 'shared/components/InlineButton';


const style = {
  title: {
    color: Colors.gray700,
  },
  warnTitle: {
    color: '#fff',
    background: Colors.red900,
    padding: '14px 24px',
  },
  dialogBody: {
    paddingTop: '30px',
  },
  btn: {
    marginLeft: '8px',
  },
  warnBtnText: {
    color: Colors.red900,
  },
  closeIcon: {
    position: 'absolute',
    right: 8,
    top: 8,
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  errorBlock: {
    padding: 20,
    color: Colors.red900,
    background: Colors.red50,
    width: '100%',
    margin: '10px 0px',
    boxSizing: 'border-box',
  },
};

export default class ErrorImageDialog extends Component {

  submit = () => {
    const {onSubmit, closeDialog} = this.props;
    if (_.isFunction(onSubmit)) {
      onSubmit();
    }
    closeDialog();
  };

  openMessenger = () => {
    const {errorMessage, closeDialog} = this.props;
    if (window.Intercom) {
      const text = `Hello Crazylister, I've tried to upload an image and got this error: ${errorMessage}`;
      window.Intercom('showNewMessage', text);
      closeDialog();
    }
  };

  render() {
    const { open, errorMessage, closeDialog} = this.props;
    const actions = [
      <FlatButton
        label="Cancel"
        onClick={closeDialog}
      />,
      <FlatButton
        label="Retry Upload"
        style={style.warnBtnText}
        onClick={this.submit}
        keyboardFocused
      />,
    ];
    return (
      <Dialog
        title={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <CloseModalButton
              onClick={closeDialog}
              style={style.closeIcon}
              white
            />
            <ErrorIcon color="#fff" size={32} />
            <span style={{paddingLeft: 10}}>Image upload failed</span>
          </div>
        }
        actions={actions}
        actionsContainerStyle={style.actions}
        modal={false}
        open={open}
        onRequestClose={closeDialog}
        titleStyle={style.warnTitle}
        style={{zIndex: 1501}}
      >
        <div style={style.dialogBody}>
          Image upload failed due to:<br/>
          <div style={style.errorBlock}>{errorMessage}</div>
          If you don’t know how to fix this you may <InlineButton
            style={{color: Colors.red900}}
            onClick={this.openMessenger}
          >
            ask for help
          </InlineButton> from Crazylister’s team.<br/>
          We are always happy to help.
        </div>
      </Dialog>
    );
  }
}

ErrorImageDialog.propTypes = {
  open: propTypes.bool.isRequired,
  errorMessage: propTypes.string.isRequired,
  closeDialog: propTypes.func.isRequired,
  onSubmit: propTypes.func,
};